<template>
  <div></div>
</template>
<script>
import i18n from '@/languages/languages'
import { getUserRoles } from '@/utils/checkRoles'

export default {
  data () {
    return {
      currentUserId: ''
    }
  },
  created () {
    this.setCurrentUser()
    this.handleIamNotifications()
  },
  destroyed () {
    this.$store.state.Pusher.unsubscribe('iam_newcase')
    this.$store.state.Pusher.unsubscribe('iam_newphone_' + this.currentUserId)
  },
  methods: {
    setCurrentUser () {
      this.currentUserId = getUserRoles().id
    },
    notifyAboutIncomingPhone (data) {
      // Let's check whether notification permissions have already been granted
      if (Notification.permission === 'granted') {
        // If it's okay let's create a notification
        let notification = new Notification(data.messageText)
        notification.onclick = () => this.pushToUser(data)
      } else if (Notification.permission !== 'denied') { // Otherwise, we need to ask the user for permission
        Notification.requestPermission().then(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === 'granted') {
            let notification = new Notification(data.messageText)
            notification.onclick = () => this.pushToUser(data)
          }
        })
      }
    },
    notifyAboutIam (data) {
      // Let's check whether notification permissions have already been granted
      if (Notification.permission === 'granted') {
        // If it's okay let's create a notification
        let notification = new Notification(i18n.t('notifications.iamNewCase'))
        notification.onclick = () => this.pushToCase(data)
      } else if (Notification.permission !== 'denied') { // Otherwise, we need to ask the user for permission
        Notification.requestPermission().then(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === 'granted') {
            let notification = new Notification(i18n.t('notifications.iamNewCase'))
            notification.onclick = () => this.pushToCase(data)
          }
        })
      }
    },
    handleIamNotifications () {
      this.channelNewCase = this.$store.state.Pusher.subscribe('iam_newcase')
      this.channelNewCase.bind('iam_newcase', data => {
        this.notifyAboutIam(data)
      })
      this.channelIncomingPhone = this.$store.state.Pusher.subscribe('iam_newphone_' + this.currentUserId)
      this.channelIncomingPhone.bind('iam_newphone_' + this.currentUserId, data => {
        this.notifyAboutIncomingPhone(data)
      })
    },
    pushToCase (id) {
      this.$router.push({ name: 'EXCMCaseShow', params: { id: '/core/public/index.php/api/e_x_c_m_cases/' + id } })
    },
    pushToUser (data) {
      if (data.isCompany) {
        this.$router.push({ name: 'FirmShow', params: { id: '/core/public/index.php/api/user_datas/' + data.userId } })
      } else {
        this.$router.push({ name: 'UserDataShow', params: { id: '/core/public/index.php/api/user_datas/' + data.userId } })
      }
    }
  }
}
</script>
